<template>
  <div class="app-content">
    <div class="wrapper" v-if="recharge">
      <div class="tilte-text"> 我的推广位 </div>
      <div class="desc"> 推广流程：创建专属推广位->获取推广链接（二维码）->粉丝购票下单->结算推广佣金 </div>
      <!--    <div class="official-tips">已授权公众号？<div class="official-enter" @click="toOffical">点击进入公众号系统<img src="~@/assets/img/official/home_btn_arrow.png"/></div></div>-->
      <div class="my-purse">
        <p class="tilte-text"> 我的资产 </p>
        <ul class="purse-info" :style="promoteStyleObj">
          <li>
            <div class="li-title">总收入（元）</div>
            <div class="li-desc">{{ account.balance }}</div>
          </li>
          <!--          <li>-->
          <!--            <div class="li-title">待结算（元）</div>-->
          <!--            <div class="li-desc">{{account.waitSettleAmount}}</div>-->
          <!--          </li>-->
          <li>
            <div class="li-title">可用金额（元）</div>
            <div class="li-desc">{{ account.usable_balance }}</div>
          </li>
          <li>
            <div class="li-title">
              冻结金额
              <Poptip trigger="hover" placement="top">
                <div slot="content" class="poptip-content" style="color: #333;">
                  推广订单，影片上映2小时后结算，7天内可提现；api订单，按市场价先冻结定金，订单成交后释放定金并扣除订单实际应付金额。
                </div>
                <Icon type="ios-help-circle-outline" size="20" color="#fff" />
              </Poptip>
            </div>
            <div class="li-desc">{{ account.freeze_amount }}</div>
          </li>
          <li>
            <span class="withdraw-btn" @click="withdraw">提现</span>
          </li>
        </ul>
      </div>
      <div class="data-trend">
        <p class="tilte-text">近30日数据趋势</p>
        <div class="echart-content">
          <div class="echart-dom" style="max-width: 930px" id="chartLineBox">

          </div>
          <div class="echar-desc">
            <div class="detail-item">
              <span class="detail-badge bg-orange"></span>
              <span class="detail-title">点击数:</span>
              <span class="detail-content">{{ report.clickNum }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-badge bg-blue"></span>
              <span class="detail-title">预估订单量:</span>
              <span class="detail-content">{{ report.validOrderNum }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-badge bg-pink"></span>
              <span class="detail-title">预估收入:</span>
              <span class="detail-content">{{ report.validIncome }}</span>
            </div>
          </div>
          <div class="echart-info">
            <p class="font-16">报表说明：</p>
            <p class="font-14">1.订单数、订单金额、预估佣金更新都可能有延迟，延迟时间在10分钟左右。</p>
            <p class="font-14">2.本报表显示在指定的时间段内发生的订单状况。</p>
            <p class="font-14">3.本报表显示的数据非最终确认结算的数据。</p>
          </div>
        </div>
      </div>
      <div class="promotion-trend">
        <p class="tilte-text">推广位数据趋势</p>
        <div class="table-wrapper">
          <Table border :columns="columns" :data="list" :loading="listLoading" :row-class-name="rowClassName">
            <template slot-scope="{ row }" slot="app_name">
              {{ row.app_name }}
            </template>
            <template slot-scope="{ row, index }" slot="action">
              <span class="show-excel" @click="toReport(row)">查看报表</span>
            </template>
          </Table>
          <div style="padding: 10px 0px">
            <Page :total="total" :current="searchForm.page" show-sizer show-elevator show-total @on-change="changePage">
            </Page>
          </div>
        </div>
      </div>
      <!--          <withdraw ref="withraw" :info="withdrawInfo"></withdraw>-->
      <!--    新提现页面-->
    </div>
    <withdraw-index :balance="account.balance" ref="withdrawIndex" v-if="!recharge"
      :max_withdraw_amount="account.max_withdraw_amount" :official="false"></withdraw-index>
  </div>
</template>

<script>
import echarts from 'echarts'
import {
  Table,
  Button,
  Page,
  Icon,
  Poptip
} from 'view-design'
import promoteWithdrawalsBg from '@/assets/img/promotion/promote_withdrawals_bg.png'
import Withdraw from '@/components/promotion/Withdraw.vue'
import withdrawIndex from '@/views/pc/withdraw/index.vue'
import { index, getIndexAppList } from '@/api/promotion'
export default {
  name: "PromotionHome",
  components: {
    Table,
    Button,
    Page,
    Withdraw,
    Icon,
    Poptip,
    withdrawIndex
  },
  data: function () {
    return {
      promoteStyleObj: {
        backgroundImage: 'url(' + promoteWithdrawalsBg + ')',
        backgroundSize: 'cover'
      },
      chartLine: undefined,
      columns: [{
        title: '推广位名称',
        slot: 'app_name',
        minWidth: 30
      },
      {
        title: 'AppKey',
        key: 'app_key',
        minWidth: 30
      },
      {
        title: '30日点击数',
        key: 'clickNum',
        minWidth: 30
      },
      {
        title: '30日订单',
        key: 'validOrderNum',
        minWidth: 30
      },
      {
        title: '30日预估收入',
        key: 'validIncome',
        minWidth: 30
      },
      {
        title: '操作',
        slot: 'action',
        width: 150,
        align: 'center',
        minWidth: 150
      }
      ],
      account: [],
      report: {
        dayList: [],
        clickNum: 0,
        validIncome: 0,
        validOrderNum: 0,
        clickNumList: [],
        validIncomeList: [],
        validOrderNumList: [],
      },
      withdrawInfo: {
        max_withdraw_amount: ''
      },
      list: [],
      listLoading: false,
      total: 0,
      searchForm: {
        page: 1,
        pagesize: 10,
      },
      recharge: true
    }
  },
  mounted: function () {
    this.initData()
    this.getList(true)
    this.listLoading = true
    // this.initEchart()
    this.listLoading = false
  },
  methods: {
    initData() {
      index().then(response => {
        this.report = response.data.appReport
        this.account = response.data.account
        this.withdrawInfo.max_withdraw_amount = response.data.account.max_withdraw_amount
        this.listLoading = false
        this.initEchart();
      })
    },
    initEchart: function () {

      if (this.report.dayList.length == 0) {
        this.report.dayList = ['暂无数据']
      }

      if (this.report.clickNumList.length == 0) {
        this.report.clickNumList = [0];
      }

      if (this.report.validOrderNumList.length == 0) {
        this.report.validOrderNumList = [0];
      }
      if (this.report.validOrderNumList.length == 0) {
        this.report.validOrderNumList = [0];
      }
      this.chartLine = echarts.init(document.getElementById('chartLineBox'))
      // 指定图表的配置项和数据
      var option = {
        tooltip: { //设置tip提示
          trigger: 'axis'
        },

        legend: { //设置区分（哪条线属于什么）
          data: ['点击数', '预估订单量', '预估收入']
        },
        color: ['#3D9EFC', '#FF8622', '#FF4F76'], //设置区分（每条线是什么颜色，和 legend 一一对应）
        xAxis: { //设置x轴
          type: 'category',
          boundaryGap: false, //坐标轴两边不留白
          data: this.report.dayList,
          name: '', //X轴 name
          nameTextStyle: { //坐标轴名称的文字样式
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 0, 20]
          },
          axisLine: { //坐标轴轴线相关设置。
            lineStyle: {
              color: '#FA6F53',
            }
          }
        },
        yAxis: {
          name: '',
          nameTextStyle: {
            color: '#FA6F53',
            fontSize: 16,
            padding: [0, 0, 10, 0]
          },
          axisLine: {
            lineStyle: {
              color: '#FA6F53',
            }
          },
          type: 'value'
        },
        series: [{
          name: '预估订单量',
          data: this.report.validOrderNumList,
          type: 'line', // 类型为折线图
          lineStyle: { // 线条样式 => 必须使用normal属性
            normal: {
              color: '#3D9EFC',
            }
          },
        },
        {
          name: '点击数',
          data: this.report.clickNumList,
          type: 'line',
          lineStyle: {
            normal: {
              color: '#FF8622',
            }
          },
        },
        {
          name: '预估收入',
          data: this.report.validOrderNumList,
          type: 'line',
          lineStyle: {
            normal: {
              color: '#FF4F76',
            }
          },
        }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    },

    //推广位列表
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.page = 1
      getIndexAppList().then((response) => {
        this.listLoading = false
        if (response.code != 200) {
          this.$Message.error(response.msg)
          return
        }
        this.list = response.data.list
        this.total = response.data.total
      })
    },

    //查看推广位
    toReport(row) {
      this.$store.dispatch('nav/changePromotionActiveIndex', 2)
      this.$router.push({
        path: '/pc/promotion/report',
        query: {
          app_key: row.app_key
        }
      })
    },

    rowClassName: function (row, index) {
      if (index % 2 === 0) {
        return 'bg-fa'
      } else {
        return 'bg-white'
      }
    },
    changePage: function () {

    },
    withdraw: function () {
      // this.$refs.withraw.init()
      // this.recharge = false
      this.$router.push('/pc/user/accountWithdrawal')
    },
    toOffical() {
      this.$router.push({ path: '/pc/official/home' })
    }
  }
}
</script>

<style scoped>
.bg-orange {
  background: #ff8622;
}

.bg-blue {
  background: #3d9efc;
}

.bg-pink {
  background: #ff4f76;
}

.font-16 {
  font-size: 16px;
}

.font-14 {
  font-size: 14px;
}

.tilte-text {
  font-size: 20px;
  color: #222222;
  text-align: left;
  font-weight: bold;
}

.wrapper {
  width: 100%;
}

.wrapper .desc {
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.wrapper .my-purse {
  margin-top: 30px;
  width: 100%;
}

.wrapper .my-purse .purse-info {
  display: flex;
  list-style: none;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  margin-top: 0.4rem;
}

.wrapper .my-purse .purse-info li {
  flex: 1;
  padding: 0.56rem 0.8rem;
}

.wrapper .my-purse .purse-info li .li-title {
  opacity: 0.8;
  font-size: 16px;
  color: #ffffff;
}

.wrapper .my-purse .purse-info li .li-desc {
  font-size: 24px;
  color: #ffffff;
  margin-top: 8px;
}

.wrapper .my-purse .purse-info li .withdraw-btn {
  background: #ffffff;
  border-radius: 2px;
  font-size: 16px;
  color: #3d9efc;
  text-align: center;
  padding: 0.18rem 0.68rem;
  display: inline-block;
  cursor: pointer;
}

.wrapper .data-trend {
  margin-top: 0.68rem;
}

.wrapper .echart-content {
  border: 1px solid #eeeeee;
  border-radius: 4px;
  width: 100%;
  margin-top: 0.24rem;
}

.wrapper .echart-dom {
  height: 4.74rem;
  padding: 0.4rem;
}

.wrapper .echart-content .echar-desc {
  display: flex;
  padding: 0.4rem;
  align-items: center;
  flex-wrap: wrap;
}

.wrapper .echart-content .echar-desc .detail-item {
  margin-right: 0.68rem;
}

.wrapper .echart-content .echar-desc .detail-item .detail-badge {
  border-radius: 100%;
  -webkit-box-shadow: 0 0 0 1px #fff;
  box-shadow: 0 0 0 1px #fff;
  width: 8px;
  height: 8px;
  display: inline-block;
  position: relative;
  top: -1px;
  margin-right: 10px;
}

.wrapper .echart-content .echar-desc .detail-item .detail-title {
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  padding-right: 10px;
}

.wrapper .echart-content .echar-desc .detail-item .detail-content {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
}

.wrapper .echart-content .echart-info {
  padding: 0.4rem;
  color: #999999;
}

.wrapper .promotion-trend {
  margin-top: 0.68rem;
}

.wrapper .promotion-trend .table-wrapper {
  margin-top: 0.4rem;
}

.table-wrapper .show-excel {
  font-size: 14px;
  color: #ff4f76;
  cursor: pointer;
}




.official-tips {
  background: #FFFBE6;
  margin-top: 30px;
  height: 48px;
  line-height: 48px;
  padding-left: 20px;
  font-family: Alibaba-PuHuiTi-R;
  font-size: 16px;
  color: #222222;
  display: flex;
  align-items: center;
}

.official-tips .official-enter {
  margin-left: 10px;
  font-family: Alibaba-PuHuiTi-M;
  color: #FF4F76;
}

.official-tips .official-enter img {
  width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/promotion/home/Index.vue